import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "add-lg",
  "use": "add-lg-usage",
  "viewBox": "0 0 52 52",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 52 52\" id=\"add-lg\"><path d=\"M9 24h34v4H9v-4z\" /><path d=\"M28 9v34h-4V9h4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol